import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, useSlots, nextTick, computed, watch, toRefs } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'UiAccordion',
  props: {
    initialState: { type: Boolean, default: false },
    initialHeight: { default: 0 },
    watchInitial: { type: Boolean, default: false }
  },
  emits: ['change'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const slots = useSlots()

const props = __props

const emit = __emit

const state = ref<boolean>(props.initialState)
const contentRef = ref<HTMLElement | null>()
const height = ref<number>(0)

const heightValue = computed(() => {
  return state.value ? stylesGenerator(height.value) : stylesGenerator(Number(props.initialHeight))
})

const isShowButton = computed(() => {
  return props.initialHeight < height.value
})

function getContentHeight() {
  nextTick(() => {
    height.value = (contentRef.value?.scrollHeight || 0) + 1
  })
}
onMounted(() => {
  getContentHeight()
})

if (props.watchInitial) {
  watch(
    () => props.initialState,
    (val) => {
      state.value = val
      getContentHeight()
    },
    {
      immediate: true,
    }
  )
}

function toggle() {
  state.value = !state.value
  emit('change')
  getContentHeight()
}

function stylesGenerator(val: number) {
  return `${val}px`
}

const render = () =>
  slots.default?.({
    state: state.value,
    isShowButton: isShowButton.value,
    toggle,
    contentRef,
    height: heightValue.value,
    collapse: () => {
      state.value = false
    },
  })

const __returned__ = { slots, props, emit, state, contentRef, height, heightValue, isShowButton, getContentHeight, toggle, stylesGenerator, render, onMounted, ref, useSlots, nextTick, computed, watch, toRefs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})